<!-- 
	富文本组件 Z05
	1、富文本：背景颜色、
	2、全屏：是、否
-->
<template>
	<view class="component-style" :style="wrapperStyle">
		<!-- <view class="html-box" v-html="data.content"></view> -->
		<up-parse :content="data.content"></up-parse>
	</view>
</template>

<script setup>
	import defaultImage from "@/static/images/tit_one_icon.png";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//背景颜色
					"backgroundColor": {
						type: String,
						default: '#ffffff'
					},
					//是否填充（0否 1是）
					"isFillet": {
						type: Number,
						default: 0
					},
					//富文本内容
					"content": {
						type: String,
						default: ''
					}
				}
			}
		}
	});
	
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		const {
			backgroundColor,
			isFillet
		} = props.data;
		/**
		 * 判断是否填充，不填充，保留一部分间距
		 */
		let paddingPx = 1;
		if(isFillet == 0){
			paddingPx = 10;
		}
		return `
			background-color: ${backgroundColor || '#f8f8f8'};
			padding-top: ${paddingPx}px;
			padding-bottom: ${paddingPx}px;
			padding-left: ${paddingPx}px;
			padding-right: ${paddingPx}px;
		`;
	});
</script>

<style lang="less" scoped>
	.component-style {
		width: 100%;
		overflow: hidden;
		/* 保证长单词或 URL 自动换行，防止横向溢出 */
		  word-wrap: break-word;     /* 兼容老浏览器 */
		  word-break: break-word;    /* 更现代的写法，推荐 */
	}
	.component-style .html-box {
		min-height: 20px;
	}
	.component-style .html-box p{		
		 margin: 0;
	}
	.component-style .html-box img {
	    max-width: 100%;
	}
</style>
